/* global $:true */
// http://unbxd.com/documentation/site-search/v2-recommendations-analytics/#integratinganalytics
import debug from "debug";
import plugin from '../../lib/plugin';
const MODULE_NAME = 'app.core/modules/unbxd-implementation';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-unbxd-skus-wrapper]';
const REMOVE_FROM_CART_ELEMENT_SELECTOR = '[data-remove-from-cart]';
const REMOVE_FROM_CART_ATTR = 'data-remove-from-cart';
const REMOVE_FROM_CART_PRICE_ATTR = 'data-remove-from-cart-price';
const REMOVE_FROM_CART_QTY_ATTR = 'data-remove-from-cart-qty';
const SEARCH_FORM = '#global-search-form';
const SEARCH_INPUT = '#q';
const SKU_ATTR = 'data-code';
const PRODUCT_SKU_ATTR = 'data-parentcode';
const RANK_ATTR = 'data-rank';
const PAGE_TYPE_ATTR = 'data-pagetype';
const WIDGET_ATTR = 'data-widget';
const REQUEST_ID_ATTR = 'data-request-id';
const SEARCH_QUERY_ATTR= 'data-search-query';
const CATEGORY_PATH_ATTR = 'data-category-path';
const CATEGORY_PAGE_TYPE_ATTR = 'data-category-page-type';
const PRODUCT_TEASER_SELECTOR = '[data-product-teaser]';
const UNBXD_RECOMMENDATIONS_BLOCK_SELECTOR = '[data-unbxd-recommendations-block]';

const UNBXD_ORDER_ATTR = '[data-unbxd-order-item]';
const UNBXD_PID_ATTR = 'data-unbxd-param_pid';
const UNBXD_PRICE_ATTR = 'data-unbxd-param_price';
const UNBXD_QTY_ATTR = 'data-unbxd-param_qty';
const UNBXD_COOKIE_ATTR = 'data-cookie-name';
const UNBXD_RECOMMENDATIONS_BLOCK_WIDGET_ATTR = 'data-unbxd-recommendations-block-widget';
const UNBXD_RECOMMENDATIONS_BLOCK_PAGETYPE_ATTR = 'data-unbxd-recommentaions-block-pagetype';


class UnbxdImplementation {

	constructor (element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$productTeaser = this.$element.find(PRODUCT_TEASER_SELECTOR);
		this.$removeFromCart = $(REMOVE_FROM_CART_ELEMENT_SELECTOR);
		this.$searchForm = $(SEARCH_FORM);
		this.$searchInput = $(SEARCH_INPUT);
		this.$recommendationsBlocks = $(UNBXD_RECOMMENDATIONS_BLOCK_SELECTOR);
		log('UnbxdImplementation', element);
		this.init();
		this.watch();
	}

	onClick(variantId, productId, rank, pagetype, widget, requestId) {
		if (typeof(Unbxd) !== 'undefined') {
			if (pagetype == '' || pagetype.length == 0) {
				pagetype = null;
			}
			if (widget == '' || widget.length == 0) {
				widget = null;
			}
			var pid = productId != null && productId.length > 0 ? productId : variantId;
			Unbxd.track( "click" ,{
				"variantId" : variantId,
				"pid" : pid,
				"prank" : rank,
				"boxType" : null,
				"requestId" : requestId,
				'experience_pagetype': pagetype, 
				'experience_widget': widget
			});
		}
	}

	getOrderCookie(c_name) {
		if (document.cookie.length > 0) {
			var c_start = document.cookie.indexOf(c_name + "=");
			if (c_start != -1) {
				c_start = c_start + c_name.length + 1;
				var c_end = document.cookie.indexOf(";", c_start);
				if (c_end == -1) {
					c_end = document.cookie.length;
				}
				return unescape(document.cookie.substring(c_start, c_end));
			}
		}
		return "";
	}

	createOrderCookie (name, value, days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		}
		else {
			expires = "";
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	order() {
		window.dataLayer =window.dataLayer || [];
		var products = Array();
		var i= 0;
		var mod = this;
		var cookieWasSet = true;
		$(UNBXD_ORDER_ATTR).each(function() {
			var cookieId = $(this).attr(UNBXD_COOKIE_ATTR);
			var cookie = mod.getOrderCookie(cookieId);
			if (cookie === "") {
				mod.createOrderCookie(cookieId, "true", 365);		
				cookieWasSet = false;		
			}
			var pid = $(this).attr(UNBXD_PID_ATTR);
			var price = $(this).attr(UNBXD_PRICE_ATTR);
			var qty = $(this).attr(UNBXD_QTY_ATTR);
			var product = {};
			product.pid = pid;
			product.price = price;
			product.qty = qty;
			products[i] =product;
			i++;	
		});

		if (!cookieWasSet && products.length > 0) {
			if (typeof(Unbxd) !== 'undefined') {
				products.forEach(function(product) {
					Unbxd.track( "order" , product);
				});
			}
		}
	}

	addToCart(productId, qty, price, variantId, pagetype, widget) {
		window.dataLayer = window.dataLayer || [];
		if (pagetype == '' || pagetype.length == 0) {
			pagetype = null;
		}
		if (widget == '' || widget.length == 0) {
			widget = null;
		}
		if (typeof(Unbxd) !== 'undefined') {
			var pid = productId != null && productId.length > 0 ? productId : variantId;
			Unbxd.track( "addToCart" , {
				"pid": pid,
				"price": price,
				"qty": qty,
				'experience_pagetype': pagetype, 
				'experience_widget': widget,
				"variantId":variantId
			});
			this.addToCartOnClick(productId, variantId, pagetype, widget);
		}
	}

	addToCartOnClick(productId, variantId, pagetype, widget) {
		var pid = productId != null && productId.length > 0 ? productId : variantId;
		var teaser = this.$productTeaser.find('[' + SKU_ATTR + ' = "'+variantId+'"]');
		if (typeof(teaser) !== 'undefined' && teaser.length > 0) {
			var teaserEl = teaser[0];
			var rank = $(teaserEl).closest(PRODUCT_TEASER_SELECTOR).attr(RANK_ATTR);
			var requestId = $(teaserEl).attr(REQUEST_ID_ATTR);		
			var pageType = $(teaserEl).attr(CATEGORY_PAGE_TYPE_ATTR);
			var categoryPath = $(teaserEl).attr(CATEGORY_PATH_ATTR);
			var searchQuery = $(teaserEl).attr(SEARCH_QUERY_ATTR);
			if (requestId.length == 0) {
				requestId = null;
			}	
			if (categoryPath.length ==0) {
				categoryPath = null;
			}
			
			Unbxd.track( "click" , {
				"pid": pid,
				"prank" : rank,				
				"query": searchQuery,
				"page" : categoryPath,
				"page_type" : pageType,
				'experience_pagetype': pagetype, 
				'experience_widget': widget,
				"requestId" : requestId
			});					
		}
	}

	removeFromCart(variantId, productId, qty, price) {
		if (typeof(Unbxd) !== 'undefined') {
			var pid = productId != null && productId.length > 0 ? productId : variantId;
			Unbxd.track( "cartRemoval" , {
					'pid': pid,
					'variantId' : variantId,
					'price': price,
					'qty': qty
				});
		}
	}

	search() {
		var searchQuery = this.$searchInput.val();
		if (searchQuery.length > 0) {
			if (typeof(Unbxd) !== 'undefined') {
				Unbxd.track( "search" , {
					"query": searchQuery
				});
			}
		}
	}

	recommendationsBlockImpression() {
		var mod = this;
		this.$recommendationsBlocks.each(function() {
			var $block = $(this);
			if (typeof(Unbxd) !== 'undefined') {
				var pagetype = $block.attr(UNBXD_RECOMMENDATIONS_BLOCK_PAGETYPE_ATTR);
				var widget = $block.attr(UNBXD_RECOMMENDATIONS_BLOCK_WIDGET_ATTR);
				var products = Array();
				var $teasers = $block.find(PRODUCT_TEASER_SELECTOR);
				$teasers.each(function() {
					var $teaser = $(this);
					var $teaserLink = $teaser.find('[' + SKU_ATTR + ']');
					if (typeof($teaserLink) !== 'undefined') {
						var sku = $teaserLink.attr(SKU_ATTR);
						products.push(sku);
					}
				});
				if (pagetype == '' || pagetype.length == 0) {
					pagetype = null;
				}
				if (widget == '' || widget.length == 0) {
					widget = null;
				}
				Unbxd.track("experience_impression", {
					"experience_pagetype": pagetype,
					"experience_widget" : widget,
					 pids_list: products
				});
			}
		});
	}

	init () {
		var rank =1;
		this.$productTeaser.each(function() {
			var $product = $(this);
			$product.attr(RANK_ATTR, rank);
			rank++;
		});

		var mod = this;
		setTimeout(function() {
			mod.order();
			mod.recommendationsBlockImpression();
		},200);
	}
	watch() {
		var mod = this;
		this.$productTeaser.find('[' + SKU_ATTR + ']').on('click', function(){
			var sku = $(this).attr(SKU_ATTR);
			var productSku = $(this).attr(PRODUCT_SKU_ATTR);
			var rank = $(this).closest(PRODUCT_TEASER_SELECTOR).attr(RANK_ATTR);
			var widget = $(this).attr(WIDGET_ATTR);
			var requestId = $(this).attr(REQUEST_ID_ATTR);
			var pagetype = $(this).attr(PAGE_TYPE_ATTR);
			mod.onClick(sku, productSku, rank, pagetype,widget,requestId);
		});

		this.$searchForm.on('submit', function() {
			mod.search();
		});

		this.$removeFromCart.on('click', function() {
			var sku = $(this).attr(REMOVE_FROM_CART_ATTR);
			var productSku = $(this).attr(PRODUCT_SKU_ATTR);
			var qty = $(this).attr(REMOVE_FROM_CART_QTY_ATTR);
			var price = $(this).attr(REMOVE_FROM_CART_PRICE_ATTR);
			mod.removeFromCart(sku, productSku, qty, price);
		});

		$(document).on('added-to-cart', function(event, productId, qty,  price, variantId) {
			var $teaser = $('[data-code="'+variantId+'"]');
			if ($teaser.length >0) {
				var widget = $teaser.attr(WIDGET_ATTR);
				var pagetype = $teaser.attr(PAGE_TYPE_ATTR);				
				mod.addToCart(productId, qty, price, variantId, pagetype, widget);
			}
		});
	}
}

plugin('unbxdImplementation', UnbxdImplementation);

export function exec () {
	$(document).ready(() => {
		log('binding');
		$(ELEMENT_SELECTOR).unbxdImplementation();
		log('bound');
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/unbxd-implementation/index.js